import { useEffect } from "react";
import { OuterContentContainer } from "@shared/ui/OuterContentContainer";
import { Loader } from "@shared/ui/Loader";
import { Program as ProgramType } from "@platform/types/dashboard.types";
import {
  User as UserType,
  Organization as OrganizationType,
} from "@platform/types/platform.types";
import { PROGRAM_MOUNT, useProgramDispatch } from "../../ProgramContext";
import { ProgramPhasesContainer } from "../ProgramPhases/ProgramPhasesContainer";
import { ProgramParticipantListContainer } from "../ProgramParticipants/ProgramParticipantListContainer";
import { ProgramWelcomeKitContainer } from "../ProgramWelcomeKit/ProgramWelcomeKitContainer";
import { ProgramWorkbookDownloadContainer } from "../ProgramWorkbookDownload/ProgramWorkbookDownloadContainer";
import { ProgramDialogs } from "../ProgramDialogs/ProgramDialogs";
import { ProgramCircleContainer } from "../ProgramCircle/ProgramCircleContainer";

export type Props = {
  program: ProgramType | null;
  user: UserType | null;
  organization: OrganizationType | null;
};

export function Program({ program, user, organization, isLoading }: Props) {
  const dispatch = useProgramDispatch();

  useEffect(() => {
    if (program && user && organization) {
      dispatch({
        type: PROGRAM_MOUNT,
        payload: { program, user, organization },
      });
    }
  }, [program, user, organization, dispatch]);

  return (
    <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
      {!program ? (
        <Loader isFullPage />
      ) : (
        <>
          <ProgramCircleContainer />
          <ProgramPhasesContainer />
          <ProgramParticipantListContainer />
          <ProgramWorkbookDownloadContainer />
          <ProgramWelcomeKitContainer />
          <ProgramDialogs />
        </>
      )}
    </OuterContentContainer>
  );
}

export default Program;
